import { FALLBACK_LANGUAGE, LANGUAGE_CODES } from './Languages';

/**
 * i18next resolution options, extracted out of Localization.js so they can be unit-tested without
 * triggering that file's import-time side effects (it calls i18n.init() and reads cookies as soon
 * as it's imported). `Languages.ts` is pure, so importing the shipped list here is safe.
 *
 * supportedLngs + load: 'languageOnly' + nonExplicitSupportedLngs collapse any region-flavoured
 * locale tag (en-JM, en_JM, de-CH, pl-PL, ...) onto its base language before resource lookup, so
 * i18next resolves to a bundle this build actually ships instead of rendering raw keys. This
 * matters because the storefront's own LANGUAGES enum is written straight into the
 * storefront_locale cookie that this app's language detector reads verbatim, and because
 * i18n.language is sent verbatim as x-preferred-locale to a backend that has no de-CH catalog.
 *
 * supportedLngs is LANGUAGE_CODES rather than a literal list: it must be exactly the set of
 * catalogs Localization.js registers. Hard-coding ['en', 'de'] here — which is what this file
 * shipped before the nine-language rollout — silently whitelists away every other language while
 * leaving the build and the pipeline green.
 *
 * fallbackLng is unconditionally 'en' (previously `import.meta.env.PROD ? 'en' : null`, which also
 * had a typo — `import.meta.PROD` — that silently disabled the prod fallback until fixed in
 * 5681d6ad) so dev and prod behave identically for an unsupported locale, and so a key the
 * pipeline has not translated yet renders its English text rather than its key.
 */
export const I18N_RESOLUTION_OPTIONS = {
  fallbackLng: FALLBACK_LANGUAGE,
  supportedLngs: LANGUAGE_CODES,
  load: 'languageOnly' as const,
  nonExplicitSupportedLngs: true,
};
